import { PageStatus, ValidationErrorData } from './common';
import { GdShowConditionAutobudgetPriority } from './graphql-grid';

export interface FeedFilterChangeRateFormState {
    rateType: FeedFilterRateType;
    rate?: number;
    status: PageStatus;
    errors?: Array<ValidationErrorData>;
}

export interface FeedFilterChangePriorityFormState {
    autobudgetPriority: GdShowConditionAutobudgetPriority;
    status: PageStatus;
}

export enum FeedFilterRateType {
    cpc = 'cpc',
    cpa = 'cpa'
}

export interface FeedFilterPricesInfo {
    id: string;
    autobudgetPriority?: GdShowConditionAutobudgetPriority;
    priceCpc?: number;
    priceCpa?: number;
}

export interface FeedFiltersState {
    rateForm: FeedFilterChangeRateFormState;
    priorityForm: FeedFilterChangePriorityFormState;
}
